import { module } from 'angular';
import App from '../../../app';

class SCR0102Controller {
	
	constructor ($scope, $uibModalInstance, $timeout, httpService, gridService, popupService){
		this.$scope = $scope;
		this.$uibModalInstance = $uibModalInstance;
		this.$timeout = $timeout;
		this.httpService = httpService;
		this.gridService = gridService;
		this.popupService = popupService;
		
		this.initWindow(640, 640);
		this.initText();
		this.initSearch();
		this.initSelect();
		
		this.$timeout(() => {
			this.setGridHeight();
			this.initUserGridOption();
			this.getUserList();
		});
	}
	
	initWindow(width, height){
		const { top, left } = this.popupService.calculatePosition(width,height);
		
		this.width = width;
		this.height = height;
		this.top = top;
		this.left = left;
		this.zIndex = this.popupService.getModalZIndex();
	}
	
	initText(){
		this.text = {
			userSearch : bxMsg('manageUser.userSearch'),
			userId : bxMsg('manageUser.userId'),
			userNm : bxMsg('manageUser.userNm'),
			email : bxMsg('manageUser.email'),
			dutyNm : bxMsg('manageUser.dutyNm'),
			deptNm : bxMsg('manageUser.deptNm'),
			roleId : bxMsg('manageUser.roleId'),
			confirmOk : bxMsg('common.confirmOk'),
			confirmCancel : bxMsg('common.confirmCancel'),
			resetSearch : bxMsg('common.resetSearch'),
			search : bxMsg('common.search'),
		};
	}
	
	initSearch(){
		this.searchParam = {};
	}
	
	initSelect(){
		this.select = this.gridService.getSelect(10);
	}
	
	initUserGridOption(){
		this.gridView = new RealGridJS.GridView('grid');
		this.dataProvider = new RealGridJS.LocalDataProvider();
		this.gridView.setDataSource(this.dataProvider);		
		this.gridService.setDefaultSetting(this.gridView);
		this.gridView.setCheckBar({visible: false});
		this.gridView.setDisplayOptions({fitStyle: 'evenFill'}); 
		
		this.dataProvider.setFields([
            {
            	fieldName: "no",
            	calculateCallback: (dataRow, fieldName, fieldNames, values) => {
            		return this.gridService.getNoField(this.select.pageSize, dataRow, this.pageNumber);
        		}
    		}, 
    		 {fieldName: "userId"}, {fieldName: "userNm"}, {fieldName: "deptNm"}, {fieldName: "roleId"}
        ]);
		
		this.gridView.setColumns([
			{ name: "no", fieldName: "no", header : { text: "no" } , width: 40, styles: { textAlignment: 'center' } },
			{ name: "userId", fieldName: "userId", header : { text: this.text.userId }, width: 100, styles: { textAlignment: 'center' } },
			{ name: "userNm", fieldName: "userNm", header : { text: this.text.userNm }, width: 100, styles: { textAlignment: 'center' } },
			{ name: "deptNm", fieldName: "deptNm", header : { text: this.text.deptNm }, width: 100, styles: { textAlignment: 'center' } },
			{ name: "roleId", fieldName: "roleId", header : { text: this.text.roleId }, width: 100, styles: { textAlignment: 'center' } }
		]);
		
		this.gridView.onDataCellDblClicked = (grid, cell) => {
			this.closeModal(true)
		};
	}
	
	getUserList(goToFirst = false) {
		const {pageNumber, pageSize} = this.getPageInfo();
		var url = `/users?pageNumber=${ goToFirst ? 1 : pageNumber}&pageSize=${pageSize}`;
		
		this.httpService.get(url, this.searchParam).then(data => {
			if(goToFirst) {
				this.pageNumber = 1;
				this.$scope.$broadcast(`resetPage`, this.pageNumber);
			}
			
			this.recordsCount = data.totalCnt;
			this.dataProvider.setRows(data.userOutList);
		});
	}
	
	getPageInfo() {
		return {
			pageNumber: this.pageNumber || 1,
			pageSize: this.select.pageSize
		};
	}
	
	resetSearch(){
		this.searchParam = {};
		this.getUserList(true);
	}
	
	search(){
		this.getUserList(true);
	}
	
	blur($event){
		$event.target.blur();
	}
	
	pageBtnClick(num){
		this.pageNumber = num;
		this.getUserList(num === 1);
	}
	
	closeModal(isOk){
		if(isOk){
			const selection = this.gridView.getSelectedRows();
			
			if(selection.length === 0){
				this.$uibModalInstance.dismiss();
			} else {
				this.$uibModalInstance.close(this.gridView.getValues(selection[0]));
			}
		} else {
			this.$uibModalInstance.dismiss();
		}
		
		this.gridView.destroy();
		this.dataProvider.destroy();
	}
	
	setGridHeight() {
		let $msgGrid = $('#grid');
		let height = this.gridService.getGridHeight(this.select.pageSize);
		
		$msgGrid.height(height);
	}
	
}

module(App.name).controller('SCR0102Controller', SCR0102Controller);




// WEBPACK FOOTER //
// ./src/app/views/popup/SCR0102/SCR0102.controller.js